import { AxiosRequestConfig } from "axios";
import api from "../../apiClient";
import {
  PlayerDetails,
  CreatePlayerDetailsRequest,
  UpdatePlayerDetailsRequest,
  PlayerDetailsListParams,
  PlayerDetailsListResponse,
} from "./types";

class PlayerDetailsService {
  async createPlayerDetails(
    data: CreatePlayerDetailsRequest,
    config?: AxiosRequestConfig,
  ): Promise<PlayerDetails> {
    const response = await api.post("/player-details", data, config);
    return response.data.data;
  }

  async getPlayerDetails(
    id: string,
    config?: AxiosRequestConfig,
  ): Promise<PlayerDetails> {
    const response = await api.get(`/player-details/${id}`, config);
    return response.data.data;
  }

  async getPlayerDetailsByPlayerId(
    playerId: number,
    config?: AxiosRequestConfig,
  ): Promise<PlayerDetails> {
    const response = await api.get(
      `/player-details/player/${playerId}`,
      config,
    );
    return response.data.data;
  }

  async listPlayerDetails(
    params?: PlayerDetailsListParams,
    config?: AxiosRequestConfig,
  ): Promise<PlayerDetailsListResponse> {
    const response = await api.get("/player-details", {
      ...config,
      params,
    });
    return response.data.data;
  }

  async updatePlayerDetails(
    id: string,
    data: UpdatePlayerDetailsRequest,
    config?: AxiosRequestConfig,
  ): Promise<PlayerDetails> {
    const response = await api.put(`/player-details/${id}`, data, config);
    return response.data.data;
  }

  async updatePlayerDetailsByPlayerId(
    playerId: number,
    data: UpdatePlayerDetailsRequest,
    config?: AxiosRequestConfig,
  ): Promise<PlayerDetails> {
    const response = await api.put(
      `/player-details/player/${playerId}`,
      data,
      config,
    );
    return response.data.data;
  }

  async deletePlayerDetails(
    id: string,
    config?: AxiosRequestConfig,
  ): Promise<void> {
    await api.delete(`/player-details/${id}`, config);
  }
}

export const playerDetailsService = new PlayerDetailsService();
